module.exports = __webpack_public_path__ + "img/waybill_banner.025b9b05.jpg";